import { createSlice } from '@reduxjs/toolkit';

import { BLACKLIST_EMAILER_FILTERS } from '@communicationManagement/data/blacklistEmailerFilters';

const initialState = {
  isModalOpen: false,
  learnerEmail: { applied: '', current: '' },
  superBatch: { applied: null, current: null },
};

export const blacklistLearnersFilter = createSlice({
  name: 'blacklistLearnersFilter',
  initialState,
  reducers: {
    setPersonalisedMenteeEmailersFilterModalState: (state, action) => {
      state.isModalOpen = action.payload;
    },
    setFilterValue: (state, action) => {
      const { type, key, value } = action.payload;
      state[key][type] = value;
    },
    applyCurrentFilter: (state, action) => {
      for (const key in BLACKLIST_EMAILER_FILTERS) {
        state[key].applied = state[key].current;
      }
      state.isModalOpen = false;
    },
    removeFilter: (state, action) => {
      state[action.payload] = initialState[action.payload];
    },
    resetFilters: (state) => {
      for (const key in BLACKLIST_EMAILER_FILTERS) {
        state[key] = initialState[key];
      }
    },
  },
});

export const {
  applyCurrentFilter,
  removeFilter,
  setPersonalisedMenteeEmailersFilterModalState,
  setFilterValue,
  resetFilters,
} = blacklistLearnersFilter.actions;

export default blacklistLearnersFilter.reducer;
